import { render, staticRenderFns } from "./veJkyGainShow.vue?vue&type=template&id=77f4a1d4&scoped=true"
import script from "./veJkyGainShow.vue?vue&type=script&lang=js"
export * from "./veJkyGainShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f4a1d4",
  null
  
)

export default component.exports